module.exports = __webpack_public_path__ + "img/cfc2fa4.jpg";